export interface PalantirMapCenter {
  latitude: number;
  longitude: number;
}

export type PalantirMapMarker = PalantirMapAvatarMarker | PalantirMapCustomerMarker;

export interface PalantirMapMarkerCommon<
  T extends PalantirMapMarkerType | PalantirMapMarkerTypeEnum,
> {
  type: T;
}

export interface PalantirMapAvatarMarker extends PalantirMapMarkerCommon<'AVATAR'> {
  latitude: number;
  longitude: number;
  url: string | null;
  zIndex: number;
}

export interface PalantirMapCustomerMarker extends PalantirMapMarkerCommon<'CUSTOMER'> {
  latitude: number;
  longitude: number;
  zIndex: number;
}

export enum PalantirMapMarkerTypeEnum {
  AVATAR = 'AVATAR',
  CUSTOMER = 'CUSTOMER',
}

export type PalantirMapMarkerType = keyof typeof PalantirMapMarkerTypeEnum;
